"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[2380],{

/***/ 2380:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ cart)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _on_sight_strategy_os_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2465);
/* harmony import */ var prettier__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3891);
/* harmony import */ var prettier__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prettier__WEBPACK_IMPORTED_MODULE_1__);




function cart({ wrapper }) {
  const sectionID = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('section-id')
  const $section = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).closest('.shopify-section')
  let sectionIsSelected = !Shopify.designMode

  // TailwindCSS variants representing different states
  const { classes } = window.config

  const urls = {
    update: '/cart/update.js',
    change: '/cart/change.js',
    add: '/cart/add.js',
    get: '/cart.json',
  }

  const selectors = {
    addByID: '[data-hook="addProductByID"]',
    cartItem: '[data-hook="cart-item"]',
    cartNote: '[data-hook="cart-note"]',
    closeCart: '[data-hook="close-cart"]',
    productForm: 'form[action="/cart/add"]:not(.listen)',
    productFormRelated: '.related_product_form',
    removeItem: '[data-hook="remove-item"]',
    toggleCart: '[data-hook="toggle-cart"]',
    upgradeToSubscriptionBtn: '[data-hook="upgrade-to-sub"]',
    updateSellingPlan: '[data-hook="update-selling-plan"]',
    quantityInput: '[data-hook="quantity"]',
    cartInner: '[data-cart-section="inner"]',
    overlay: '[data-hook="overlay"]',
    cartCount: '[data-hook="cart-count"]',
    //
    removeBundle: '[data-hook="remove-bundle"]',
    removeKit: '[data-hook="remove-kit"]',
  }

  let state = {
    focusOnClose: null,
  }

  ;(function init() {
    render()

    // Automatically opens cart on redirect from '/cart' if '?open_cart' is present in the URL
    if (new URL(location).searchParams.has('open_cart')) open()

    initOutsideEventListeners()
    initInsideEventListeners()

    if (Shopify && Shopify.designMode) {
      initDesignModeListeners()
    }

    // Watch for Gorgias chat. Hide if the cart is open
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor('#chat-button', checkGorgiasChat)
  })()

  function setFormListeners() {
    const mainForms = [...document.querySelectorAll(selectors.productForm)]
    mainForms.forEach((f) => {
      f.addEventListener('submit', onProductSubmit)
      f.classList.add('listen')
    })
  }

  window.setFormListeners = setFormListeners

  function initOutsideEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', selectors.addByID, addProductByID)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cart:addProductByID', onAddProductByID)

  //   $(document)
  // .off('click', selectors.addByID)
  // .on('click', selectors.addByID, addProductByID);
    
    setFormListeners()

    setTimeout(() => {
      const allForms = [...document.querySelectorAll(selectors.productFormRelated)]
      allForms.forEach((f) => {
        f.addEventListener('submit', onProductSubmit)
      })
      console.log('allForms', allForms)
    }, 3000)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cart:open', open)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cart:close', close)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cart:toggle', toggle)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('popup:close', close)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document)
      .off('click', selectors.toggleCart)
      .on('click', selectors.toggleCart, (event) => {
        state.focusOnClose = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target)
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:toggle')
      })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cart:forceRender', render)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cart:reset', reset)

    // Octane quiz app
    document.addEventListener(
      'octane.quiz.addToCart',
      function (e) {
        render()
        open()
      },
      false
    )

    // Loop subscription app
    document.addEventListener('loopByobAddToCartSuccessEvent', function (e) {
      render()
      open()
    })
  }

  function initInsideEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', selectors.closeCart, () => jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('cart:close'))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', selectors.removeItem, removeFromCart)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', selectors.removeBundle, removeBundleFromCart)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', selectors.removeKit, removeKitFromCart)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', selectors.upgradeToSubscriptionBtn, updateSubscription)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('change', selectors.updateSellingPlan, updateSubscription)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('quantity-box:change', selectors.quantityInput, (0,_on_sight_strategy_os_utilities__WEBPACK_IMPORTED_MODULE_2__/* .debounce */ .sg)(changeItemQuantity, 300))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('change', selectors.cartNote, updateCartNote)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('change', '[data-hook="upsell-variants"]', function (e) {
      const $atc = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings('[data-hook="addProductByID"]')
      $atc.data('variant-id', this.value)
    })
  }

  function initDesignModeListeners() {
    // open cart on section selection
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('shopify:section:select', function (event) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).is($section)) {
        sectionIsSelected = true
        open()
      }
    })

    // close cart on section deselection
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('shopify:section:deselect', function (event) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).is($section)) {
        sectionIsSelected = false
        close()
      }
    })

    // re-load cart on section load
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('shopify:section:load', function (event) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).attr('id') === $section.attr('id')) {
        setTimeout(() => {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:reset')
        }, 200)
      }
    })
  }

  // Example of how to add a product to the cart without a form
  function addProductByID(event) {
    const id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('variant-id')

    // Uses a custom event so we can trigger this from anywhere
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:addProductByID', { trigger: this, id, quantity: 1 })
  }

  // Handle the event when a product is added to the cart by ID
  function onAddProductByID(event, { trigger, id, quantity }) {
    addToCart({ id, quantity }, trigger)
  }

  // Handle the submission of a product form
  function onProductSubmit(e) {
    console.log(786876, e)
    console.log('Hit on submit here....');
    e.preventDefault()

    const $form = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
    console.log("form==", $form);

    const data = $form.serialize()
    console.log("form DAta==", data);

    addToCart(data, this)
  }

  // Add a product to the cart
  function addToCart(data, trigger) {
    console.log('addToCart / data', data)
    console.log('addtocart/ trigger', trigger);

    // Update which element we should focus on when the cart closes
    state.focusOnClose = jquery__WEBPACK_IMPORTED_MODULE_0___default()(trigger)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(trigger).addClass(classes.loading)
    setTimeout( () => {
    processCartRequest({
      data,
      url: urls.add,
      beforeSend: (edata) => {
        console.log('before dataa===', edata );
        },
      success: function (res) {
        console.log("Res", res)
        // Build cart
        render()

        // Open cart
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:open')

        jquery__WEBPACK_IMPORTED_MODULE_0___default()(trigger).removeClass(classes.loading)
      },
      error: function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(trigger).removeClass(classes.loading).addClass(classes.error)
      },
    })
  },1000)
  }

  // Remove an item from the cart
  function removeFromCart() {
    const $item = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest(selectors.cartItem)
    let key = $item.data('key')

    let data = {
      updates: {
        [key]: 0,
      },
    }

    // Add loading indicator to cart item
    $item.addClass(classes.loading)

    processCartRequest({
      data,
      url: urls.update,
      success: function () {
        render()

        $item.removeClass(classes.loading)
      },
    })
  }

  // Remove a bundle from the cart
  function removeBundleFromCart() {
    // Look for product items within this bundle wrapper
    const $bundle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('[data-hook="cart-bundle"]')
    const $items = $bundle.find(selectors.cartItem)

    // Add loading indicator to cart item
    $bundle.addClass(classes.loading)

    let updates = {}
    $items.each(function () {
      const item = this
      const key = jquery__WEBPACK_IMPORTED_MODULE_0___default()(item).data('key')

      updates[key] = 0
    })

    processCartRequest({
      data: { updates },
      url: urls.update,
      success: function () {
        render()

        $bundle.removeClass(classes.loading)
      },
    })
  }

  // Remove a kit from the cart
  function removeKitFromCart() {
    // Look for product items within this kit wrapper
    const $kit = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('[data-hook="cart-kit"]')
    const $items = $kit.find(selectors.cartItem)

    // Add loading indicator to cart item
    $kit.addClass(classes.loading)

    const kitKey = $kit.data('key')
    let updates = {
      [kitKey]: 0,
    }

    $items.each(function () {
      const item = this
      const key = jquery__WEBPACK_IMPORTED_MODULE_0___default()(item).data('key')

      updates[key] = 0
    })

    processCartRequest({
      data: { updates },
      url: urls.update,
      success: function () {
        render()
      },
    })
  }

  // Handle the change in quantity for an item
  function changeItemQuantity(event) {
    const $item = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).closest(selectors.cartItem)
    let key = $item.data('key')

    let data = {
      updates: {
        [key]: jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).val(),
      },
    }

    // Add loading indicator to cart item
    $item.addClass(classes.loading)

    processCartRequest({
      data,
      url: urls.update,
      success: function () {
        render()

        $item.removeClass(classes.loading)
      },
    })
  }

  // Update the item subscription / selling_plan
  function updateSubscription(event) {
    event.preventDefault()

    const $trigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $item = $trigger.closest(selectors.cartItem)
    let { key, quantity, sellingPlan } = $trigger.data()

    if ($trigger.val()) {
      sellingPlan = $trigger.val()
    }

    const data = {
      quantity: quantity,
      id: key,
      selling_plan: sellingPlan === 'onetime' ? '' : sellingPlan,
    }

    processCartRequest({
      data,
      url: urls.change,
      success: function () {
        render()

        $item.removeClass(classes.loading)
      },
    })
  }

  function getCart(callback) {
    processCartRequest({
      data: null,
      url: urls.get,
      success: callback,
    })
  }

  //
  function checkGorgiasChat() {
    console.log('checkGorgiasChat', jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active))

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('#gorgias-chat-container').addClass('!hidden')
    }
  }

  // Toggle the cart open/close state
  function toggle() {
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)) {
      close()
    } else {
      open()
    }
  }

  // Open the cart
  function open() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#gorgias-chat-container').addClass('!hidden')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).addClass(classes.active)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:show')

    // Lock scrolling outside the cart
    ;(0,_on_sight_strategy_os_utilities__WEBPACK_IMPORTED_MODULE_2__/* .toggleScroll */ .YZ)({ lock: true })

    // Restrict tabbing outside of the cart
    if (!Shopify.designMode) restrictTabbing()
  }

  // Close the cart
  function close() {
    if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)) return

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).removeClass(classes.active)

    // Remove overlay
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:hide')

    // Unlock scrolling outside the cart
    ;(0,_on_sight_strategy_os_utilities__WEBPACK_IMPORTED_MODULE_2__/* .toggleScroll */ .YZ)({ lock: false })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#gorgias-chat-container').removeClass('!hidden')

    // Unrestrict tabbing outside of the cart
    if (!Shopify.designMode) allowTabbing()

    // Return focus to the element that triggered the cart to open
    state.focusOnClose && state.focusOnClose.trigger('focus')
  }

  // Update the cart note
  function updateCartNote(event) {
    const $note = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)

    const data = {
      note: $note.val(),
    }

    processCartRequest({ data, url: urls.update, success: null })
  }

  // Restrict tabbing outside the cart
  function restrictTabbing() {
    const $inertElements = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).parent().siblings().not(selectors.overlay)
    $inertElements.attr('inert', true)
  }

  // Allow tabbing outside the cart
  function allowTabbing() {
    const $inertElements = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).parent().siblings().not(selectors.overlay)
    $inertElements.removeAttr('inert')
  }

  function updateCartCount() {
    getCart(function (cart) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.cartCount).toggleClass(classes.active, !!cart.item_count)

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:update', { cart })
    })
  }

  // Render the cart
  function render() {
    updateCartCount()

    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(`/?sections=${sectionID}`).then(function (response) {
      if (response[sectionID]) {
        const $cartInner = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.cartInner)
        const $newCartInner = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response[sectionID]).find(selectors.cartInner)

        $cartInner.replaceWith($newCartInner)
      }
    })
  }

  // Reset the cart and all event listeners
  function reset() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:hide')
    render()
    open()
  }

  // Process a cart request
  function processCartRequest({ data, url, success = render, error }) {
    console.log("hello-33", data);
    let params = {
      url,
      data,
      method: 'POST',
      dataType: 'json',
      beforeSend: function(bs) {
        // setting a timeout
        console.log('before Send data', bs);
        
    },
      success,
      error: function (err) {
        console.warn(err)

        if (error) error()
      },
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(params)
  }
}


/***/ })

}]);